import { render } from "./Integration.vue?vue&type=template&id=547f8628&scoped=true"
import script from "./Integration.vue?vue&type=script&lang=js"
export * from "./Integration.vue?vue&type=script&lang=js"

import "./Integration.vue?vue&type=style&index=0&id=547f8628&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\caleb\\OneDrive\\Desktop\\apps\\kff_ordering_portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547f8628"]])

export default __exports__